require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ecole-polytechnique-paris-lx-2-5-2-0.json") })
        }
      }, "path---ecole-polytechnique-paris-lx-2-5-2-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ecole-polytechnique-paris-lx-2-5-2-0!./.cache/json/ecole-polytechnique-paris-lx-2-5-2-0.json
// module id = 402
// module chunks = 231608221292675